import styled from "styled-components";

const Predictor = styled.h3.attrs({ className: "text-uppercase" })`
  align-self: center;
  margin: 0;
`;

export default Predictor;
